import {
  CLEAN_LOCATION_FORM,
  CREATE_GLOVO_INTEGRATION,
  CREATE_WOLT_INTEGRATION_SAGA,
  DELETE_LOCATION_SAGA,
  EDIT_CASH_SYSTEM_SAGA,
  EDIT_LOCATION_ITEM_SAGA,
  FETCH_CASH_SYSTEM_SAGA,
  FETCH_LOCATIONS_SAGA,
  FETCH_ORGANIZATION_SAGA,
  FETCH_PAYMENT_TYPES_SAGA,
  GET_CURRENCIES_SAGA,
  GET_LANGUAGES_SAGA,
  GET_LOCATION_BY_ID_SAGA,
  GET_AGGREGATOR_DATA_SAGA,
  PATCH_INTEGRATION_SAGA,
  SEND_IIKO_ORGANIZATIONS_SAGA,
  SWITCH_LOCATION_INTEGRATION_MODE,
  FETCH_ORDER_TYPES_SAGA,
  UPDATE_AGGREGATOR_DATA_SAGA,
  CLEAR_AGGREGATOR_DATA,
  GET_POS_IDS_SAGA,
  GET_YANDEX_CREDENTIALS_SAGA,
  CREATE_YANDEX_INTEGRATION_SAGA,
  EDIT_CHECK_FIELDS_SAGA,
} from "./types/actionTypes";

export const fetchLocations = (
  page: number = 1,
  field: string | null = null,
  direction: number | null = null,
  q: string | null = null
) => {
  return { type: FETCH_LOCATIONS_SAGA, payload: { page, field, direction, q } };
};

export const fetchLocationById = (resti_id: string) => ({
  type: GET_LOCATION_BY_ID_SAGA,
  payload: resti_id,
});

export const editLocationData = (payload: any) => ({
  type: EDIT_LOCATION_ITEM_SAGA,
  payload,
});

export const cleanLocationForm = () => ({ type: CLEAN_LOCATION_FORM });

export const fetchOrganizations = (api_login: string, pos_type: string) => ({
  type: FETCH_ORGANIZATION_SAGA,
  payload: { api_login, pos_type },
});

export const fetchPaymentTypes = (resti_id: string) => ({
  type: FETCH_PAYMENT_TYPES_SAGA,
  payload: resti_id,
});

export const fetchOrderTypes = (resti_id: string) => ({
  type: FETCH_ORDER_TYPES_SAGA,
  payload: resti_id,
});

export const switchLocationIntegration = (payload: any) => ({
  type: SWITCH_LOCATION_INTEGRATION_MODE,
  payload,
});

export const createCashSystem = (payload: any) => ({
  type: SEND_IIKO_ORGANIZATIONS_SAGA,
  payload,
});

export const createGlovo = (payload: any) => ({
  type: CREATE_GLOVO_INTEGRATION,
  payload,
});

export const createWolt = (payload: any) => ({
  type: CREATE_WOLT_INTEGRATION_SAGA,
  payload,
});

export const deleteLocation = (payload: {
  resti_id: string;
  page: number;
}) => ({ type: DELETE_LOCATION_SAGA, payload });

export const fetchCashSystem = (payload: string) => ({
  type: FETCH_CASH_SYSTEM_SAGA,
  payload,
});

export const editCashSystem = (payload: any) => ({
  type: EDIT_CASH_SYSTEM_SAGA,
  payload,
});

export const patchIntegration = (payload: any) => ({
  type: PATCH_INTEGRATION_SAGA,
  payload,
});

export const fetchLanguages = () => ({ type: GET_LANGUAGES_SAGA });

export const fetchCurrencies = () => ({ type: GET_CURRENCIES_SAGA });

export const fetchAggregatorData = (payload: {
  resti_id: string;
  aggregator: string;
}) => ({ type: GET_AGGREGATOR_DATA_SAGA, payload });

export const updateAggregatorData = (payload: any) => ({
  type: UPDATE_AGGREGATOR_DATA_SAGA,
  payload,
});

export const clearAggregatorData = () => ({ type: CLEAR_AGGREGATOR_DATA });

export const getPosIds = (payload: any) => ({
  type: GET_POS_IDS_SAGA,
  payload,
});

//YANDEX
export const getYandexCredentials = (payload: string) => ({
  type: GET_YANDEX_CREDENTIALS_SAGA,
  payload,
});

export const createYandexIntegration = (payload: any) => ({
  type: CREATE_YANDEX_INTEGRATION_SAGA,
  payload,
});

export const editChecksField = (payload: any) => ({
  type: EDIT_CHECK_FIELDS_SAGA,
  payload,
});
